import {observable, action, runInAction} from 'mobx'
import {json, _encodeParam, get} from "../../../../utils/ajax";
import {message} from 'antd'
import {handleSearchAndPage, setStore, ValueObjToObj} from "../../../../utils/Utils";

class newSbomStore {
    @observable list  //主列表数据
    @observable pagination  //主列表分页
    @observable driveModel  //驱动方式
    @observable loading  //loading
    @observable carList  //车系
    @observable displacement  //发动机排量
    @observable emissionNormal  //排放标准
    @observable deploy  //配置
    @observable transmission  //变速器
    @observable selectCarCode  //车系code
    @observable carCode   //车系code
    @observable initTableSelectData//初始化下拉数据

    @observable carYear  //年款
    @observable searchFields  //搜索表单绑定
    @observable editVisible  //修改框是否显示属性
    @observable editFields  //修改回显字段
    @observable confirmLoading  //修改确认
    @observable showDrawer
    @observable endOpen
    @observable editModalStatus   //修改模态框
    @observable exportModal  //导出模态框
    @observable exportCarMaterialCode  //导出模态框
    @observable exportVin  //导出模态框
    @observable modalKey  //导出模态框

    @observable editType  //新增模态框类型
    @observable carSeries  //新增模态框类型


    constructor() {
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.loading=false
        this.driveModel = [] //驱动方式
        this.displacement = []  //发动机排量
        this.emissionNormal = []  //排放标准
        this.deploy = []  //配置
        this.transmission = []  //变速器
        this.carList = [] //车系
        this.carCode = ''
        this.carYear = [] //年款
        this.searchFields = {
            carmaterialCodeOrCarmaterialName: '',
            carseriesCode: '',
            transmission: '',
            carYear: '',
            deploy: '',
            emissionNormal: '',
            displacement: '',
            driveModel: '',
            interiorColor: ''
        }
        this.editVisible = false
        this.editFields = {
            rootMaterialCode: '',
            name: '',
            enName: '',
            carMaterialCode: '',
            carMaterialName: '',
            vin: '',
            startDate: '',
            deactivationDate: '',
            selfMadeDate: '',
            qty: '',
        }
        this.confirmLoading = false
        this.showDrawer = false
        this.endOpen = false
        this.modelStatus = false
        this.selectCarCode = ''
        this.initTableSelectData = {
            modelYearSet: [],
            powerSet: [],
            transTypeSet: [],
            driveTypeSet: [],
            displacementSet: [],
            allocationSet: [],
        }
        this.carSeries = '' //通过车系查询
        this.editModalStatus = false
        this.exportModal = false
        this.exportCarMaterialCode = ''
        this.exportVin = ''
        this.modalKey = ''
        this.editType=''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /*** 页面初始化*/
    @action
    initPage = async (page) => {
        this.loading = true
        this.carSeries=''
        let searchFields = {
            carMaterialCode: this.searchFields.carMaterialCode ? this.searchFields.carMaterialCode : '',
            name: this.searchFields.name ? this.searchFields.name : '',
            rootMaterialCode: this.searchFields.rootMaterialCode ? this.searchFields.rootMaterialCode : '',
            vin: this.searchFields.vin ? this.searchFields.vin : '',
        }
        let search = handleSearchAndPage(page, this.pagination, searchFields)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/olftAssembly:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            // this.initSelectValues()
        })
    }


    /*** 页面初始化*/
    @action
    initCarSeriesPage = async () => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/olftAssembly/carSeriesQueryOLFTAssemblyPartsList?search.carSeries=${this.carSeries}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /***搜索框车系数据 ***/
    @action
    initCarseries = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/dragonCarSeriesDropFrame`)
        runInAction(() => {
            this.carList = Array.isArray(res) ? res : []
        })
    }

    /***
     * 选择车系后请求配置数据
     * @param value
     */
    @action
    selectCarData = (value) => {
        this.selectCarCode = value
    }

    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields, fields) => {
        this[fields] = {...this[fields], ...changedFields}
    }

    /*** 绑定主页面搜索框值****/
    @action
    onEditFormField = (changeFields, fields) => {
        const change = ValueObjToObj(changeFields)
        this[fields] = {...this[fields], ...change}
    }

    /***导出*/
    @action
    getUrl = () => {
        const url = `${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesconfiguration/export/excel/all`
        return `${url}?${_encodeParam()}`
    }

    /*** 清空搜索框*/
    @action
    clearForm = () => {
        this.searchFields = {}
        this.list=[]
        this.pagination = {
            current: 0,
            total:0,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 0,
            showTotal: () => `总共 0 条`
        }
    }

    /**打开修改***/
    @action
    editModal = async (type,id,searchArg) => {
        this.editType = type
        if(this.editType === '新增'){
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/olftAssembly/instantiateTheVINQuery/${searchArg}`)
            runInAction(() => {
                this.editFields = {
                    carMaterialCode:res.carMaterialCode,
                    carMaterialName:res.carMaterialName,
                    vin:res.vin
                }
                this.editModalStatus = true
            })
        }else{
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/olftAssembly/id/${id}`)
            runInAction(() => {
                this.editFields = res
                this.editModalStatus = true
            })
        }

    }

    /****确认修改**/
    @action
    saveEdit = async () => {
        this.confirmLoading = true
        let  res ={}
        if(this.editType === '新增'){
            res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/olftAssembly/insert`, this.editFields)
        }else{
            res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/olftAssembly/update`, this.editFields)
        }
        if (res.status) {
            runInAction(() => {
                message.success(`${this.editType}成功`)
                this.editVisible = false
                this.editModalStatus = false
                this.confirmLoading = false
            })
            this.initPage(this.pagination.current)
        } else {
            runInAction(() => {
                this.confirmLoading = false
                message.error(`${this.editType}失败`)
            })
        }
    }

    /**删除***/
    @action
    deleteRow = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/olftAssembly/delete/${id}`)
        if (res.status === 1) {
            message.success(res.data)
        } else {
            message.warn(res.msg)
        }
        this.initPage()
    }

    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose = () => {
        this.showDrawer = false
    }


    /**
     * 关闭导出框
     */
    @action
    handleExportVisible = () => {
        this.endOpen = false
        this.carSeriesCodeValue = ''
        this.exportModal = true
    }


}

export default new newSbomStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sbom/NewBom/store.js